import { Skeleton } from "@/components/ui/baseUi/skeleton"

export function BoxShopShoppingListItemSkeleton() {
  return (
    <div className="flex flex-wrap gap-3">
      <Skeleton className="h-45 w-40 rounded-2xl" />
      <Skeleton className="h-45 w-40 rounded-2xl" />
      <Skeleton className="h-45 w-40 rounded-2xl" />
    </div>
  )
}
